import { render, staticRenderFns } from "./RootProfile.vue?vue&type=template&id=60076afa"
import script from "./RootProfile.vue?vue&type=script&lang=js"
export * from "./RootProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports